const constants = {
  USER_LOADING_START: 'USER_LOADING_START',
  USER_LOADING_END: 'USER_LOADING_END',
  USER_FETCH: 'USER_FETCH',
  USER_CLEAR: 'USER_CLEAR',
  USER_SET_IS_EDIT: 'USER_SET_IS_EDIT',
  USER_CHANGE_FORM: 'USER_CHANGE_FORM',
  USER_SET_ERROR: 'USER_SET_ERROR',
  USER_SAVE_SUCCESS: 'USER_SAVE_SUCCESS',
  USER_COMPANIES_FETCH: 'USER_COMPANIES_FETCH',
  USER_COMPANIES_LOADING_START: 'USER_COMPANIES_LOADING_START',
  USER_COMPANIES_LOADING_END: 'USER_COMPANIES_LOADING_END',
};

export default constants;
